import { useMutation } from '@tanstack/vue-query';
import { postV9AlertsDashboardAlertGroupCountByDashboardId } from '@/api-client/alert/queries/alert-common-v9-controller/alert-common-v9-controller';
import type { DashboardAlertRequestBody } from '@/api-client/alert/model';

export interface DashboardAlertCountRequest {
  dashboardId: number;
  request: DashboardAlertRequestBody;
  frameName?: string;
  isPolling?: boolean;
  isTimeout?: boolean;
  signal?: AbortSignal;
}

/**
 * 대시보드 알람 그룹별 개수 조회 composable
 */
export const useGetDashboardAlertCountData = () => {
  const { mutateAsync } = useMutation({
    mutationFn: async ({
      dashboardId,
      request,
      frameName,
      isPolling,
      isTimeout,
      signal,
    }: DashboardAlertCountRequest) => {
      return postV9AlertsDashboardAlertGroupCountByDashboardId(
        dashboardId,
        request,
        {
          frameName,
          params: { isPolling, isTimeout },
        },
        signal,
      );
    },
  });

  return { getDashboardAlertCountData: mutateAsync };
};
